import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { notesApi } from 'api/notes';
import { Note } from 'api/notes/types';

export const useBtlNotes = (applicationId: string): UseQueryResult<Note[]> =>
  useQuery(['btl-notes', applicationId], () => (applicationId ? notesApi.getBtlNotes(applicationId) : []), {
    enabled: !!applicationId,
  });
